exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__payment-card-date___3RUyu{position:relative;z-index:10;display:flex;flex-flow:column;color:#ecf0f1}.styles__payment-card-date___3RUyu .styles__valid-date___3UBA-{padding-left:6.5rem;text-transform:uppercase;font-size:10px;font-weight:700}.styles__payment-card-date___3RUyu .styles__to-date___2_bh6{padding-left:6.5rem;text-shadow:0 1px 3px rgba(44,62,80,.7);font-family:OCR A Std;font-size:14px}", ""]);

// exports
exports.locals = {
	"payment-card-date": "styles__payment-card-date___3RUyu",
	"valid-date": "styles__valid-date___3UBA-",
	"to-date": "styles__to-date___2_bh6"
};